  export async function fetchMovie(title) {
    const response = await fetch(
      `https://ui.dev/api/courses/react-query/movies/${title}`
    )
  
    if (!response.ok) {
      throw new Error('fetch failed')
    }
  
    return response.json()
  }
  
  export async function fetchDirector(id) {
    const response = await fetch(
      `https://ui.dev/api/courses/react-query/director/${id}`
    )
  
    if (!response.ok) {
      throw new Error('fetch failed')
    
    }
    return response.json()
  }
  